<!--begin::Body-->
<div
  class="kt-login__body d-flex flex-column flex-xl-row-reverse align-items-center align-items-xl-stretch"
>
  <!--begin::Signin-->
  <div class="kt-login__form">
    <div class="registration-card d-flex flex-column">
      @if (invitationId) {
        <cai-accept-invitation
          [invitationId]="invitationId"
          [backgroundImage]="backgroundImage"
        ></cai-accept-invitation>
      }
      @if (!registerSuccess && !invitationId) {
        <div>
          <div class="mb-2">
            @if (!type) {
              <h3
                i18n="@@registration.user.select-account"
                [class.wallet-blue]="isCargoWallet"
              >
                Select Account
              </h3>
            }
            @if (type) {
              <h3
                i18n="@@registration.user.get-started"
                [class.wallet-blue]="isCargoWallet"
              >
                Get Started
              </h3>
            }
            <h6
              i18n="@@registration.user.free-to-sign-up"
              class="mb-3"
              [class.wallet-black]="isCargoWallet"
            >
              Free to sign up
              <a [href]="iRedirectLink" target="_blank" rel="noopener"
                ><span
                  class="material-icons info-button"
                  [class.wallet-blue-icon]="isCargoWallet"
                >
                  info
                </span></a
              >
            </h6>
            @if (!type) {
              <div
                i18n="@@registration.user.only-one-type-per-account"
                class="subtext mb-4 p-2"
                [class.wallet-black]="isCargoWallet"
              >
                You can create only one type of account per email.
              </div>
            }
          </div>
          @if (!isCargoWallet && !invitationId) {
            <div class="d-flex flex-column flex-grow-1 mb-4">
              @if (type !== "airline") {
                <button
                  [@openClose]="
                    !type || type === 'forwarder' ? 'open' : 'closed'
                  "
                  class="btn-signup-type mt-0 p-0"
                  [class.btn-signup-type-selected]="type"
                  id="fowarder_btn"
                  (click)="setType('forwarder')"
                  i18n="@@global.forwarder-caps"
                >
                  FORWARDER
                </button>
              }
              @if (type !== "forwarder") {
                <button
                  [@openClose]="!type || type === 'airline' ? 'open' : 'closed'"
                  class="btn-signup-type p-0"
                  [class.btn-signup-type-selected]="type"
                  id="airline_btn"
                  (click)="setType('airline')"
                >
                  <span i18n="@@global.airline-caps">AIRLINE</span> |
                  <span i18n="@@global.gsa-caps">GSA</span>
                </button>
              }
            </div>
          }
          @if (isGuestUser && guestUserRegisterForm) {
            <form
              autocomplete="off"
              [formGroup]="guestUserRegisterForm"
              class="guest-user-forms"
            >
              <div class="form-group">
                <label
                  i18n="@@registration.work-email"
                  for="email"
                  required
                  class="wallet-black-label"
                  >Work email</label
                >
                <input
                  email
                  type="email"
                  formControlName="email"
                  autocomplete="off"
                  (keyup)="onEmailKeyUp($event)"
                  [class.invalid]="
                    guestUserRegisterForm.controls.email.invalid &&
                    guestUserRegisterForm.controls.email.dirty
                  "
                  [class.valid]="
                    guestUserRegisterForm.controls.email.valid &&
                    guestUserRegisterForm.controls.email.dirty
                  "
                  class="form-control email-input invalid-wallet-border"
                  id="email"
                />
                @if (isEmailNew) {
                  <em class="material-icons text-success input-icon checkmark"
                    >check_circle</em
                  >
                }
                @if (isControlHasError("email", "required")) {
                  <mat-error class="wallet-error-msg">
                    <strong i18n="@@global.text-error-required-field"
                      >Required field</strong
                    >
                  </mat-error>
                }
                @if (isControlHasError("email", "pattern")) {
                  <mat-error class="wallet-error-msg">
                    <strong i18n="@@global.text-error-valid-email"
                      >Please enter a valid e-mail address</strong
                    >
                  </mat-error>
                }
                @if (
                  isControlHasError("email", "minlength") &&
                  !isControlHasError("email", "pattern")
                ) {
                  <mat-error class="wallet-error-msg">
                    <strong>
                      <span i18n="@@global.text-error-minimum-field-length"
                        >Minimum field length</span
                      >span>: {{ "3" }}
                    </strong>
                  </mat-error>
                }
                @if (isControlHasError("email", "maxlength")) {
                  <mat-error class="wallet-error-msg">
                    <strong>
                      <span i18n="@@global.text-error-maximum-field-length"
                        >Maximum field length</span
                      >span>: {{ "320" }}
                    </strong>
                  </mat-error>
                }
                @if (isControlHasError("email", "emailprovider")) {
                  <mat-error class="wallet-error-msg">
                    <strong i18n="@@regisration.text-email-not-supported"
                      >Personal email addresses are not supported. Please
                      provide a corporate email address</strong
                    >
                  </mat-error>
                }
                @if (isControlHasError("email", "alreadyregistered")) {
                  <mat-error class="wallet-error-msg">
                    <strong i18n="@@registration.text-email-already-exists"
                      >Looks like a CargoAi account with this email already
                      exists. Please
                      <a href="/auth/login">login to continue.</a></strong
                    >
                  </mat-error>
                }
              </div>
              <div class="form-group">
                <label
                  i18n="@@registration.country"
                  for="email"
                  class="wallet-black-label"
                  required
                  >Country</label
                >
                <cai-select
                  formControlName="countryCode"
                  i18n-label="@@registration.country-code"
                  label="Select your Country Code"
                  placeholder="Select your Country Code"
                  [height]="180"
                  [showIcon]="false"
                  [showTotal]="false"
                  [showLabelIcon]="true"
                  [options]="countryCodeOptions"
                  [fontColor]="'#303233'"
                  [customValue]="type"
                  [avoidTitleCase]="true"
                  [hoverWalletEffect]="true"
                >
                  <span icon>
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clip-path="url(#clip0)">
                        <path
                          d="M11.9674 20C11.9449 20 11.9207 19.9991 11.8982 19.9975C11.6407 19.9775 11.4057 19.8458 11.2532 19.6375L10.2465 18.2566C10.2265 18.2291 10.1999 18.2033 10.1707 18.1816L8.69405 17.0941C8.48571 16.94 8.35572 16.7041 8.33572 16.4466C8.31655 16.1891 8.40988 15.9366 8.59322 15.7541C8.86322 15.4825 9.26488 15.4075 9.61655 15.5616L10.6999 16.035L12.9499 13.61L13.1449 13.115L12.9499 13.4833L9.01322 11.4C8.74905 11.2408 8.58822 10.9933 8.55405 10.71C8.51905 10.4266 8.61488 10.1475 8.81738 9.94498C9.01572 9.74581 9.30155 9.66415 9.57572 9.72248L15.3007 10.935C15.334 10.9425 15.3665 10.9333 15.3882 10.9091L17.4416 8.72748C17.6707 8.48415 18.0541 8.34165 18.4949 8.33498C18.9741 8.30915 19.3707 8.47081 19.6174 8.71665C19.8632 8.96248 20.0065 9.38165 19.9999 9.83915C19.9932 10.28 19.8499 10.6641 19.6066 10.8933L17.4199 12.955C17.3949 12.9783 17.3849 13.0108 17.3924 13.0416L18.7091 18.835C18.7749 19.1125 18.6924 19.4016 18.4899 19.6058C18.289 19.8075 18.0157 19.9066 17.7282 19.87C17.4457 19.8366 17.1982 19.6791 17.0499 19.4366L14.8582 15.3841L14.4482 15.08L14.7324 15.385L12.3124 17.6341L12.7857 18.7191C12.939 19.0708 12.8632 19.4716 12.5932 19.7416C12.4257 19.9075 12.2015 20 11.9674 20ZM14.7915 14.5275C14.8332 14.5275 14.8757 14.53 14.9174 14.5358C15.1924 14.5733 15.4332 14.73 15.579 14.9666L17.7707 19.0191L18.1949 19.31L17.8999 19.0158L16.5815 13.23C16.5049 12.9116 16.6082 12.5708 16.8507 12.345L19.0357 10.2858C19.0957 10.2283 19.1632 10.06 19.1665 9.82581C19.1699 9.57831 19.0999 9.37665 19.0282 9.30498C18.9557 9.23331 18.7515 9.15581 18.5074 9.16665C18.274 9.16998 18.1066 9.23665 18.0491 9.29748L15.9965 11.4775C15.7757 11.7141 15.4407 11.8166 15.1249 11.7475L9.39988 10.535L9.20822 11.0291L9.40322 10.6608L13.3399 12.7441C13.599 12.9 13.7574 13.1408 13.7974 13.4166C13.8365 13.6933 13.7499 13.9691 13.5607 14.1741L11.109 16.8158C10.9882 16.9458 10.7999 16.9858 10.6374 16.9141L9.28238 16.3225C9.24988 16.3083 9.20905 16.315 9.18322 16.3408L10.6674 17.5083C10.764 17.58 10.849 17.665 10.9199 17.7616L11.9282 19.1441C12.0307 19.1241 12.0382 19.0833 12.0224 19.0491L11.4315 17.6941C11.3607 17.5316 11.3999 17.3425 11.529 17.2225L14.1649 14.7725C14.3374 14.6141 14.5607 14.5275 14.7915 14.5275ZM19.3216 10.5891H19.3299H19.3216Z"
                          fill="#B6B6B6"
                        />
                        <path
                          d="M8.33838 8.74988C8.18588 8.74988 8.03921 8.66571 7.96588 8.51988C7.86338 8.31405 7.94588 8.06321 8.15171 7.96071L16.0634 4.00238C16.1917 3.93738 16.3467 3.94405 16.4684 4.02071C16.5917 4.09655 16.6667 4.23071 16.6667 4.37488V7.91655C16.6667 8.14655 16.48 8.33321 16.25 8.33321C16.02 8.33321 15.8334 8.14655 15.8334 7.91655V5.04905L8.52421 8.70571C8.46505 8.73571 8.40088 8.74988 8.33838 8.74988Z"
                          fill="#B6B6B6"
                        />
                        <path
                          d="M7.1625 16.25C7.09333 16.25 7.02417 16.2333 6.96 16.1975L0.214167 12.4475C0.0825 12.3742 0 12.235 0 12.0833V4.37499C0 4.23083 0.075 4.09666 0.1975 4.02083C0.32 3.94499 0.473333 3.93833 0.6025 4.00249L8.51417 7.96083C8.72 8.06416 8.80333 8.31416 8.70083 8.51999C8.5975 8.72666 8.34667 8.80916 8.14167 8.70666L0.833333 5.04916V11.8383L7.365 15.4692C7.56583 15.5808 7.63833 15.8342 7.52667 16.0358C7.45 16.1725 7.30833 16.25 7.1625 16.25Z"
                          fill="#B6B6B6"
                        />
                        <path
                          d="M16.2503 4.79223C16.1878 4.79223 16.1245 4.77806 16.0637 4.74806L8.32866 0.88306L0.603659 4.74806C0.399492 4.84973 0.147826 4.76806 0.0444924 4.56223C-0.0580076 4.35639 0.0244925 4.10556 0.230326 4.00306L8.14199 0.0447266C8.25949 -0.0136068 8.39783 -0.0136068 8.51449 0.0447266L16.4362 4.00306C16.642 4.10639 16.7253 4.35639 16.6228 4.56223C16.5495 4.70806 16.4028 4.79223 16.2503 4.79223Z"
                          fill="#B6B6B6"
                        />
                        <path
                          d="M4.20231 9.78237C3.97231 9.78237 3.78564 9.5957 3.78564 9.3657V6.26737C3.78564 6.10987 3.87481 5.9657 4.01564 5.89487L11.9273 1.93653C12.1306 1.83487 12.3831 1.91737 12.4865 2.1232C12.589 2.32903 12.5056 2.57903 12.2998 2.68237L4.61898 6.5257V9.36653C4.61898 9.59653 4.43231 9.78237 4.20231 9.78237Z"
                          fill="#B6B6B6"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0">
                          <rect width="20" height="20" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                  </span>
                </cai-select>
                @if (isControlHasError("countryCode", "required")) {
                  <mat-error class="wallet-error-msg">
                    <strong i18n="@@global.text-error-required-field"
                      >Required field</strong
                    >
                  </mat-error>
                }
              </div>
              <div class="form-group">
                <label
                  i18n="@@registration.company-name"
                  for="company"
                  class="wallet-black-label"
                  required
                  >Company name</label
                >
                <input
                  company
                  formControlName="companyName"
                  autocomplete="off"
                  [class.invalid-wallet-border]="isCargoWallet"
                  [class.invalid]="
                    guestUserRegisterForm.controls.companyName.invalid &&
                    guestUserRegisterForm.controls.companyName.dirty
                  "
                  [class.valid]="
                    guestUserRegisterForm.controls.companyName.valid &&
                    guestUserRegisterForm.controls.companyName.dirty
                  "
                  class="form-control"
                  id="companyName"
                />
                @if (isControlHasError("companyName", "required")) {
                  <mat-error class="wallet-error-msg">
                    <strong i18n="@@global.text-error-required-field"
                      >Required field</strong
                    >
                  </mat-error>
                }
                @if (
                  isControlHasError("companyName", "minlength") &&
                  !isControlHasError("companyName", "pattern")
                ) {
                  <mat-error class="wallet-error-msg">
                    <strong>
                      <span i18n="@@global.text-error-minimum-field-length"
                        >Minimum field length</span
                      >span>: {{ "3" }}
                    </strong>
                  </mat-error>
                }
                @if (isControlHasError("companyName", "maxlength")) {
                  <mat-error class="wallet-error-msg">
                    <strong>
                      <span i18n="@@global.text-error-maximum-field-length"
                        >Maximum field length</span
                      >span>: {{ "320" }}
                    </strong>
                  </mat-error>
                }
              </div>
            </form>
          }
          @if (isCargoWallet && userTypeForm) {
            <div class="form-group" [formGroup]="userTypeForm">
              @if (isGuestUser) {
                <label
                  i18n="@@registration.company-type"
                  for="userType"
                  required
                  class="wallet-black-label"
                  >Company type</label
                >
              }
              @if (!type) {
                <cai-select
                  userType
                  formControlName="userType"
                  i18n-label="@@registration.userTypesList"
                  label="Select your account type"
                  placeholder="Select your account type"
                  [height]="180"
                  [showIcon]="false"
                  [showTotal]="false"
                  [showLabelIcon]="true"
                  [options]="userTypesOption"
                  [fontColor]="'#303233'"
                  [customValue]="type"
                  [avoidTitleCase]="true"
                  [hoverWalletEffect]="true"
                >
                  <span icon>
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clip-path="url(#clip0)">
                        <path
                          d="M11.9674 20C11.9449 20 11.9207 19.9991 11.8982 19.9975C11.6407 19.9775 11.4057 19.8458 11.2532 19.6375L10.2465 18.2566C10.2265 18.2291 10.1999 18.2033 10.1707 18.1816L8.69405 17.0941C8.48571 16.94 8.35572 16.7041 8.33572 16.4466C8.31655 16.1891 8.40988 15.9366 8.59322 15.7541C8.86322 15.4825 9.26488 15.4075 9.61655 15.5616L10.6999 16.035L12.9499 13.61L13.1449 13.115L12.9499 13.4833L9.01322 11.4C8.74905 11.2408 8.58822 10.9933 8.55405 10.71C8.51905 10.4266 8.61488 10.1475 8.81738 9.94498C9.01572 9.74581 9.30155 9.66415 9.57572 9.72248L15.3007 10.935C15.334 10.9425 15.3665 10.9333 15.3882 10.9091L17.4416 8.72748C17.6707 8.48415 18.0541 8.34165 18.4949 8.33498C18.9741 8.30915 19.3707 8.47081 19.6174 8.71665C19.8632 8.96248 20.0065 9.38165 19.9999 9.83915C19.9932 10.28 19.8499 10.6641 19.6066 10.8933L17.4199 12.955C17.3949 12.9783 17.3849 13.0108 17.3924 13.0416L18.7091 18.835C18.7749 19.1125 18.6924 19.4016 18.4899 19.6058C18.289 19.8075 18.0157 19.9066 17.7282 19.87C17.4457 19.8366 17.1982 19.6791 17.0499 19.4366L14.8582 15.3841L14.4482 15.08L14.7324 15.385L12.3124 17.6341L12.7857 18.7191C12.939 19.0708 12.8632 19.4716 12.5932 19.7416C12.4257 19.9075 12.2015 20 11.9674 20ZM14.7915 14.5275C14.8332 14.5275 14.8757 14.53 14.9174 14.5358C15.1924 14.5733 15.4332 14.73 15.579 14.9666L17.7707 19.0191L18.1949 19.31L17.8999 19.0158L16.5815 13.23C16.5049 12.9116 16.6082 12.5708 16.8507 12.345L19.0357 10.2858C19.0957 10.2283 19.1632 10.06 19.1665 9.82581C19.1699 9.57831 19.0999 9.37665 19.0282 9.30498C18.9557 9.23331 18.7515 9.15581 18.5074 9.16665C18.274 9.16998 18.1066 9.23665 18.0491 9.29748L15.9965 11.4775C15.7757 11.7141 15.4407 11.8166 15.1249 11.7475L9.39988 10.535L9.20822 11.0291L9.40322 10.6608L13.3399 12.7441C13.599 12.9 13.7574 13.1408 13.7974 13.4166C13.8365 13.6933 13.7499 13.9691 13.5607 14.1741L11.109 16.8158C10.9882 16.9458 10.7999 16.9858 10.6374 16.9141L9.28238 16.3225C9.24988 16.3083 9.20905 16.315 9.18322 16.3408L10.6674 17.5083C10.764 17.58 10.849 17.665 10.9199 17.7616L11.9282 19.1441C12.0307 19.1241 12.0382 19.0833 12.0224 19.0491L11.4315 17.6941C11.3607 17.5316 11.3999 17.3425 11.529 17.2225L14.1649 14.7725C14.3374 14.6141 14.5607 14.5275 14.7915 14.5275ZM19.3216 10.5891H19.3299H19.3216Z"
                          fill="#B6B6B6"
                        />
                        <path
                          d="M8.33838 8.74988C8.18588 8.74988 8.03921 8.66571 7.96588 8.51988C7.86338 8.31405 7.94588 8.06321 8.15171 7.96071L16.0634 4.00238C16.1917 3.93738 16.3467 3.94405 16.4684 4.02071C16.5917 4.09655 16.6667 4.23071 16.6667 4.37488V7.91655C16.6667 8.14655 16.48 8.33321 16.25 8.33321C16.02 8.33321 15.8334 8.14655 15.8334 7.91655V5.04905L8.52421 8.70571C8.46505 8.73571 8.40088 8.74988 8.33838 8.74988Z"
                          fill="#B6B6B6"
                        />
                        <path
                          d="M7.1625 16.25C7.09333 16.25 7.02417 16.2333 6.96 16.1975L0.214167 12.4475C0.0825 12.3742 0 12.235 0 12.0833V4.37499C0 4.23083 0.075 4.09666 0.1975 4.02083C0.32 3.94499 0.473333 3.93833 0.6025 4.00249L8.51417 7.96083C8.72 8.06416 8.80333 8.31416 8.70083 8.51999C8.5975 8.72666 8.34667 8.80916 8.14167 8.70666L0.833333 5.04916V11.8383L7.365 15.4692C7.56583 15.5808 7.63833 15.8342 7.52667 16.0358C7.45 16.1725 7.30833 16.25 7.1625 16.25Z"
                          fill="#B6B6B6"
                        />
                        <path
                          d="M16.2503 4.79223C16.1878 4.79223 16.1245 4.77806 16.0637 4.74806L8.32866 0.88306L0.603659 4.74806C0.399492 4.84973 0.147826 4.76806 0.0444924 4.56223C-0.0580076 4.35639 0.0244925 4.10556 0.230326 4.00306L8.14199 0.0447266C8.25949 -0.0136068 8.39783 -0.0136068 8.51449 0.0447266L16.4362 4.00306C16.642 4.10639 16.7253 4.35639 16.6228 4.56223C16.5495 4.70806 16.4028 4.79223 16.2503 4.79223Z"
                          fill="#B6B6B6"
                        />
                        <path
                          d="M4.20231 9.78237C3.97231 9.78237 3.78564 9.5957 3.78564 9.3657V6.26737C3.78564 6.10987 3.87481 5.9657 4.01564 5.89487L11.9273 1.93653C12.1306 1.83487 12.3831 1.91737 12.4865 2.1232C12.589 2.32903 12.5056 2.57903 12.2998 2.68237L4.61898 6.5257V9.36653C4.61898 9.59653 4.43231 9.78237 4.20231 9.78237Z"
                          fill="#B6B6B6"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0">
                          <rect width="20" height="20" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                  </span>
                </cai-select>
              }
              @if (isControlHasError("userType", "required")) {
                <mat-error class="wallet-error-msg">
                  <strong i18n="@@global.text-error-required-field"
                    >Required field</strong
                  >
                </mat-error>
              }
              @if (type) {
                <p
                  class="btn-signup-type mt-0 p-0"
                  [class.wallet-blue-bg]="isCargoWallet"
                  [class.btn-signup-type-selected]="type"
                  i18n="@@registration.user-type"
                >
                  {{ selectedUserType }}
                </p>
              }
            </div>
          }
          <div [@openClose]="type ? 'open' : 'closed'">
            <h4
              i18n="@@registration.user.create-account"
              class="font-weight-bold create-account-txt text-left mt-3 mb-4"
              [class.wallet-black]="isCargoWallet"
            >
              Create your account
            </h4>
            @if (registerForm) {
              <form autocomplete="off" [formGroup]="registerForm">
                <div class="form-group">
                  <label
                    i18n="@@registration.user.email-address"
                    for="email"
                    [class.wallet-black-label]="isCargoWallet"
                    required
                    >{{ isCargoWallet ? "Work Email" : "Email address" }}</label
                  >
                  <input
                    email
                    type="email"
                    formControlName="email"
                    autocomplete="off"
                    (keyup)="onEmailKeyUp($event)"
                    [class.invalid-wallet-border]="isCargoWallet"
                    [class.invalid]="
                      registerForm.controls.email.invalid &&
                      registerForm.controls.email.dirty
                    "
                    [class.valid]="
                      registerForm.controls.email.valid &&
                      registerForm.controls.email.dirty
                    "
                    class="form-control email-input"
                    id="email"
                  />
                  @if (isEmailNew) {
                    <em class="material-icons text-success input-icon checkmark"
                      >check_circle</em
                    >
                  }
                  @if (isControlHasError("email", "required")) {
                    <mat-error [class.wallet-error-msg]="isCargoWallet">
                      <strong i18n="@@global.text-error-required-field"
                        >Required field</strong
                      >
                    </mat-error>
                  }
                  @if (isControlHasError("email", "pattern")) {
                    <mat-error [class.wallet-error-msg]="isCargoWallet">
                      <strong i18n="@@global.text-error-valid-email"
                        >Please enter a valid e-mail address</strong
                      >
                    </mat-error>
                  }
                  @if (
                    isControlHasError("email", "minlength") &&
                    !isControlHasError("email", "pattern")
                  ) {
                    <mat-error [class.wallet-error-msg]="isCargoWallet">
                      <strong>
                        <span i18n="@@global.text-error-minimum-field-length"
                          >Minimum field length</span
                        >span>: {{ "3" }}
                      </strong>
                    </mat-error>
                  }
                  @if (isControlHasError("email", "maxlength")) {
                    <mat-error [class.wallet-error-msg]="isCargoWallet">
                      <strong>
                        <span i18n="@@global.text-error-maximum-field-length"
                          >Maximum field length</span
                        >span>: {{ "320" }}
                      </strong>
                    </mat-error>
                  }
                  @if (isControlHasError("email", "emailprovider")) {
                    <mat-error [class.wallet-error-msg]="isCargoWallet">
                      <strong i18n="@@regisration.text-email-not-supported"
                        >Personal email addresses are not supported. Please
                        provide a corporate email address</strong
                      >
                    </mat-error>
                  }
                  @if (isControlHasError("email", "alreadyregistered")) {
                    <mat-error [class.wallet-error-msg]="isCargoWallet">
                      <strong i18n="@@registration.text-email-already-exists"
                        >Looks like a CargoAi account with this email already
                        exists. Please
                        <a href="/auth/login">login to continue.</a></strong
                      >
                    </mat-error>
                  }
                </div>
                @if (referrer?.name) {
                  <div class="form-group">
                    <label i18n="@@global.password" for="referrer-name"
                      >Referrer</label
                    >
                    <input
                      type="text"
                      [value]="referrer.name"
                      id="referrer-name"
                      class="form-control password-input"
                      disabled
                    />
                  </div>
                }
                <cai-registration-password-field
                  [passwordControl]="registerForm.controls['password']"
                  [isCargoWallet]="isCargoWallet"
                ></cai-registration-password-field>
                <div class="d-flex flex-row">
                  <div class="form-group w-50 pe-1">
                    <label
                      required
                      for="firstName"
                      i18n="@@global.first-name"
                      [class.wallet-black-label]="isCargoWallet"
                      >First name</label
                    >
                    <input
                      type="text"
                      formControlName="firstName"
                      autocomplete="off"
                      class="form-control"
                      id="firstName"
                      [class.invalid-wallet-border]="isCargoWallet"
                      [class.invalid]="
                        registerForm.controls.firstName.invalid &&
                        registerForm.controls.firstName.dirty
                      "
                      [class.valid]="
                        registerForm.controls.firstName.valid &&
                        registerForm.controls.firstName.dirty
                      "
                    />
                    @if (
                      isControlHasError("firstName", "required") ||
                      isControlHasError("firstName", "noLetters")
                    ) {
                      <mat-error [class.wallet-error-msg]="isCargoWallet">
                        <strong i18n="@@global.text-error-required-field"
                          >Required field</strong
                        >
                      </mat-error>
                    }
                  </div>
                  <div class="form-group w-50">
                    <label
                      required
                      for="lastName"
                      i18n="@@global.last-name"
                      [class.wallet-black-label]="isCargoWallet"
                      >Last name</label
                    >
                    <input
                      type="text"
                      formControlName="lastName"
                      autocomplete="off"
                      class="form-control"
                      id="lastName"
                      [class.invalid-wallet-border]="isCargoWallet"
                      [class.invalid]="
                        registerForm.controls.lastName.invalid &&
                        registerForm.controls.lastName.dirty
                      "
                      [class.valid]="
                        registerForm.controls.lastName.valid &&
                        registerForm.controls.lastName.dirty
                      "
                    />
                    @if (
                      isControlHasError("lastName", "required") ||
                      isControlHasError("lastName", "noLetters")
                    ) {
                      <mat-error [class.wallet-error-msg]="isCargoWallet">
                        <strong i18n="@@global.text-error-required-field"
                          >Required field</strong
                        >
                      </mat-error>
                    }
                  </div>
                </div>
                <div>
                  <p [class.wallet-black-color]="isCargoWallet">
                    <span i18n="@@registration.agree">
                      By clicking below, you agree to CargoAi
                    </span>
                    <a
                      target="_blank"
                      [class.wallet-link-color]="isCargoWallet"
                      href="https://cargoai.co/terms"
                      i18n="@@registration.terms-of-service"
                      rel="noopener"
                      >Terms of Service</a
                    >
                    and
                    <a
                      target="_blank"
                      [class.wallet-link-color]="isCargoWallet"
                      href="https://cargoai.co/privacy-policy"
                      i18n="@@registration.terms-of-service"
                      rel="noopener"
                      >Privacy Policy</a
                    >
                  </p>
                </div>
                <button
                  id="btn-agree"
                  (click)="onAgreeClick()"
                  [class.wallet-blue-button]="isCargoWallet"
                  [disabled]="registerForm.invalid || isLoading || !isEmailNew"
                >
                  <span i18n="@@global.agree"> Agree </span>
                  @if (isLoading) {
                    <span
                      class="spinner-border"
                      role="status"
                      aria-hidden="true"
                    ></span>
                  }
                </button>
              </form>
            }
          </div>
          <div class="mt-2">
            @if (!isGuestUser) {
              <h5
                [class.mb-4]="!isCargoWallet"
                [class.mt-4]="isCargoWallet"
                [class.wallet-no-card-text]="isCargoWallet"
                i18n="@@registration.user.text-no-credit-card-required"
              >
                NO CREDIT CARD REQUIRED
              </h5>
            }
            @if (!type && isCargoWallet) {
              <button
                (click)="onContinueSelected()"
                [disabled]="isSubmitDisabled"
                [class.wallet-blue-button]="isCargoWallet"
              >
                <span i18n="@@global.continue"> Continue </span>
                @if (isLoading) {
                  <span
                    class="spinner-border"
                    role="status"
                    aria-hidden="true"
                  ></span>
                }
              </button>
            }
            <div
              class="d-flex justify-content-center align-items-center mt-4"
              style="gap: 16px"
            >
              <a href="/">
                <div
                  class="signup-logo"
                  [class.wallet-logo-base]="isCargoWallet"
                  [ngStyle]="{
                    'background-image': 'url(' + backgroundImage + ')',
                  }"
                ></div>
              </a>
              @if (referrer?.logoUrl) {
                <img
                  [src]="referrer.logoUrl"
                  alt="referrer logo"
                  loading="lazy"
                  style="max-width: 40%"
                />
              }
            </div>
            @if (showBrand) {
              <div class="brand-container">
                <span i18n="@@global.powered-by">Powered by</span>
                <div
                  class="cargoai-icon"
                  [ngStyle]="{
                    'background-image':
                      'url(' +
                      '/assets/media/logos/cargoai-without-logo.png' +
                      ')',
                    'text-align': 'center',
                  }"
                ></div>
              </div>
            }
          </div>
        </div>
      }
      @if (registerForm) {
        <div
          [@openClose]="registerSuccess ? 'open' : 'closed'"
          class="text-center fade-in"
        >
          <h3
            i18n="@@registration.success"
            class="success-text"
            [class.wallet-black]="isCargoWallet"
          >
            Success!
          </h3>
          <img
            class="d-block ml-auto me-auto"
            src="/assets/animation/success.gif"
            alt="success-animation"
            width="170px"
            height="170px"
            loading="lazy"
          />
          <h5
            i18n="@@registration.user.text-check-your-email"
            [class.wallet-black]="isCargoWallet"
          >
            Please check your email. We’ve sent you the link to company
            verification form.
          </h5>
          <kt-registration-progress-bar
            [isCargoWallet]="isCargoWallet"
            [disableCompanyVerification]="true"
          ></kt-registration-progress-bar>
          <div
            class="d-flex justify-content-center align-items-center mt-4"
            style="gap: 16px"
          >
            <a href="/">
              <div
                class="signup-logo"
                [class.wallet-logo-base]="isCargoWallet"
                [ngStyle]="{
                  'background-image': 'url(' + backgroundImage + ')',
                }"
              ></div>
            </a>
            @if (referrer?.logoUrl) {
              <img
                [src]="referrer.logoUrl"
                alt="referrer logo"
                loading="lazy"
                style="max-width: 40%"
              />
            }
          </div>
        </div>
      }
    </div>
  </div>
  @if (isCargoMart) {
    <kt-registration-tutorial></kt-registration-tutorial>
  }
  @if (isCargoWallet) {
    <kt-registration-video></kt-registration-video>
  }
</div>
